/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
// @ts-ignore
import globalAxios from '@/config/axiosInstance'
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ProvinceApi - axios parameter creator
 * @export
 */
export const ProvinceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinceControllerCreateProvinceForm: async (name: string, status: boolean, parent: Array, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling provinceControllerCreateProvinceForm.');
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling provinceControllerCreateProvinceForm.');
            }
            // verify required parameter 'parent' is not null or undefined
            if (parent === null || parent === undefined) {
                throw new RequiredError('parent','Required parameter parent was null or undefined when calling provinceControllerCreateProvinceForm.');
            }
            const localVarPath = `/v1/cms/api/province`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }

            if (parent !== undefined) { 
                localVarFormParams.append('parent', parent as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pageNumber 
         * @param {number} pageIndex 
         * @param {string} [name] 
         * @param {string} [slug] 
         * @param {boolean} [status] 
         * @param {boolean} [justParent] 
         * @param {string} [parent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinceControllerGetProvince: async (pageNumber: number, pageIndex: number, name?: string, slug?: string, status?: boolean, justParent?: boolean, parent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling provinceControllerGetProvince.');
            }
            // verify required parameter 'pageIndex' is not null or undefined
            if (pageIndex === null || pageIndex === undefined) {
                throw new RequiredError('pageIndex','Required parameter pageIndex was null or undefined when calling provinceControllerGetProvince.');
            }
            const localVarPath = `/v1/cms/api/province`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (justParent !== undefined) {
                localVarQueryParameter['justParent'] = justParent;
            }

            if (parent !== undefined) {
                localVarQueryParameter['parent'] = parent;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinceControllerGetProvinceMedia: async (filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            if (filename === null || filename === undefined) {
                throw new RequiredError('filename','Required parameter filename was null or undefined when calling provinceControllerGetProvinceMedia.');
            }
            const localVarPath = `/v1/cms/api/province-media/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} slug 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinceControllerUpdateProvinceForm: async (name: string, slug: string, status: boolean, parent: Array, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling provinceControllerUpdateProvinceForm.');
            }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling provinceControllerUpdateProvinceForm.');
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling provinceControllerUpdateProvinceForm.');
            }
            // verify required parameter 'parent' is not null or undefined
            if (parent === null || parent === undefined) {
                throw new RequiredError('parent','Required parameter parent was null or undefined when calling provinceControllerUpdateProvinceForm.');
            }
            const localVarPath = `/v1/cms/api/province`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (slug !== undefined) { 
                localVarFormParams.append('slug', slug as any);
            }

            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }

            if (parent !== undefined) { 
                localVarFormParams.append('parent', parent as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProvinceApi - functional programming interface
 * @export
 */
export const ProvinceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerCreateProvinceForm(name: string, status: boolean, parent: Array, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ProvinceApiAxiosParamCreator(configuration).provinceControllerCreateProvinceForm(name, status, parent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} pageNumber 
         * @param {number} pageIndex 
         * @param {string} [name] 
         * @param {string} [slug] 
         * @param {boolean} [status] 
         * @param {boolean} [justParent] 
         * @param {string} [parent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerGetProvince(pageNumber: number, pageIndex: number, name?: string, slug?: string, status?: boolean, justParent?: boolean, parent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ProvinceApiAxiosParamCreator(configuration).provinceControllerGetProvince(pageNumber, pageIndex, name, slug, status, justParent, parent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerGetProvinceMedia(filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ProvinceApiAxiosParamCreator(configuration).provinceControllerGetProvinceMedia(filename, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} slug 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerUpdateProvinceForm(name: string, slug: string, status: boolean, parent: Array, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ProvinceApiAxiosParamCreator(configuration).provinceControllerUpdateProvinceForm(name, slug, status, parent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProvinceApi - factory interface
 * @export
 */
export const ProvinceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerCreateProvinceForm(name: string, status: boolean, parent: Array, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ProvinceApiFp(configuration).provinceControllerCreateProvinceForm(name, status, parent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} pageNumber 
         * @param {number} pageIndex 
         * @param {string} [name] 
         * @param {string} [slug] 
         * @param {boolean} [status] 
         * @param {boolean} [justParent] 
         * @param {string} [parent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerGetProvince(pageNumber: number, pageIndex: number, name?: string, slug?: string, status?: boolean, justParent?: boolean, parent?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ProvinceApiFp(configuration).provinceControllerGetProvince(pageNumber, pageIndex, name, slug, status, justParent, parent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerGetProvinceMedia(filename: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ProvinceApiFp(configuration).provinceControllerGetProvinceMedia(filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {string} slug 
         * @param {boolean} status 
         * @param {Array} parent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinceControllerUpdateProvinceForm(name: string, slug: string, status: boolean, parent: Array, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ProvinceApiFp(configuration).provinceControllerUpdateProvinceForm(name, slug, status, parent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProvinceApi - object-oriented interface
 * @export
 * @class ProvinceApi
 * @extends {BaseAPI}
 */
export class ProvinceApi extends BaseAPI {
    /**
     * 
     * @param {string} name 
     * @param {boolean} status 
     * @param {Array} parent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvinceApi
     */
    public async provinceControllerCreateProvinceForm(name: string, status: boolean, parent: Array, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ProvinceApiFp(this.configuration).provinceControllerCreateProvinceForm(name, status, parent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} pageNumber 
     * @param {number} pageIndex 
     * @param {string} [name] 
     * @param {string} [slug] 
     * @param {boolean} [status] 
     * @param {boolean} [justParent] 
     * @param {string} [parent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvinceApi
     */
    public async provinceControllerGetProvince(pageNumber: number, pageIndex: number, name?: string, slug?: string, status?: boolean, justParent?: boolean, parent?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ProvinceApiFp(this.configuration).provinceControllerGetProvince(pageNumber, pageIndex, name, slug, status, justParent, parent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvinceApi
     */
    public async provinceControllerGetProvinceMedia(filename: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ProvinceApiFp(this.configuration).provinceControllerGetProvinceMedia(filename, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} name 
     * @param {string} slug 
     * @param {boolean} status 
     * @param {Array} parent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvinceApi
     */
    public async provinceControllerUpdateProvinceForm(name: string, slug: string, status: boolean, parent: Array, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ProvinceApiFp(this.configuration).provinceControllerUpdateProvinceForm(name, slug, status, parent, options).then((request) => request(this.axios, this.basePath));
    }
}
